import AppColors from 'general/constants/AppColors';
import UIHelper from 'general/helpers/UIHelper';
import PropTypes from 'prop-types';
import { CircularProgressbarWithChildren, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

HalfCircleChart.propTypes = {
  color: PropTypes.string,
  value: PropTypes.number,
  unit: PropTypes.string,
};

function HalfCircleChart({ color = AppColors.gray[300], value = 0, unit = '' }) {
  return (
    <div style={{ width: '100px', height: '60px' }}>
      <CircularProgressbarWithChildren
        value={value}
        maxValue={100}
        styles={buildStyles({
          rotation: 0.75,
          strokeLinecap: 'round',
          trailColor: AppColors.gray[300],
          pathColor: color,
        })}
        circleRatio={0.5}
      >
        <div style={{ marginTop: -5 }}>
          <span style={UIHelper.buildFontStyle('700', '22px', AppColors.gray[800])}>
            {value}
            {unit}
          </span>
        </div>
      </CircularProgressbarWithChildren>
    </div>
  );
}

export default HalfCircleChart;
